var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFruits(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "fruits") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5, 0.5)",
    fill: "none",
    stroke: "currentColor",
    className: "nc-icon-wrapper"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.518,13.046c-.656-2.331-2.878-4.046-5.518-4.046s-4.862,1.715-5.518,4.046c-1.188,5.963-4.482,8.822-4.482,13.954,0,5.29,4.477,8,10,8s10-2.71,10-8c0-5.132-3.295-7.99-4.482-13.954Z",
    strokeLinecap: "round",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52,9c0-3.314,2.686-6,6-6",
    strokeLinecap: "round",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,50l6-8,5.369-14.316c.416-1.109,1.072-2.111,1.923-2.935l9.88-9.577c1.562-1.562,4.095-1.562,5.657,0s1.562,4.095,0,5.657l-8.828,9.172-3.4,9.638c-.635,1.799,1.371,3.381,2.972,2.345l8.171-5.286c1.557-1.066,3.701-.907,5.084,.476,1.562,1.562,1.562,4.095,0,5.657l-9.338,9.636c-.98,1.012-2.09,1.89-3.301,2.611l-8.265,4.924",
    strokeLinecap: "round",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.03,28.502l5.703-2.896c1.341-.646,2.267-2.018,2.267-3.606,0-2.209-1.791-4-4-4-.353,0-.688,.06-1.014,.146",
    strokeWidth: 3,
    "data-cap": "butt",
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFruits);
export default __webpack_public_path__ + "static/media/fruits.508dfa0593486d94868612b0a8d5b68d.svg";
export { ForwardRef as ReactComponent };